import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiHomeData, type EnrollmentMultiHomeSubmitOutput } from '../../../../models'

export const getEnrollmentMultiHomeDataMock: EnrollmentMultiHomeData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/home',
}

export const submitEnrollmentMultiHomeDataMock: EnrollmentMultiHomeSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/next-page-here',
}

export const mockGetEnrollmentMultiHomeData = graphql.mutation('getEnrollmentMultiHomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiHomeDataMock } })
})

export const mockSubmitEnrollmentMultiHomeData = graphql.mutation('submitEnrollmentMultiHomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiHomeDataMock } })
})

export const mockEnrollmentMultiHome = [mockGetEnrollmentMultiHomeData, mockSubmitEnrollmentMultiHomeData]
